import { createStore, combineReducers } from "redux";
import selectHeaderItem from "./Reducers/SelectedItemReducer";
import changeTotalUnseenNotifications from './Reducers/NotificationsReducer';

export default createStore(combineReducers({selectHeaderItem, changeTotalUnseenNotifications}));
